
export default {
  components: {},
  setup() {
    return {};
  }
};
